'use client'
import {
  Card,
  Col,
  LoadMoreSection,
  Row,
  Separator,
  Skeleton,
} from '@repo/ui/components'
import { Fragment } from 'react'
import { BalanceItem } from './balance.item'
import { useGetAgentFiatTransactionHistory } from '@repo/services'
import { BalanceEmptyState } from './balance.empty-state'

export const BalanceContainer = () => {
  const currency = 'IRR'
  const { data, isLoading, fetchNextPage, hasNextPage, isFetchingNextPage } =
    useGetAgentFiatTransactionHistory({
      skip: 0,
      limit: 10,
      currency: currency as string,
    })
  const transactions = data?.pages.flatMap(
    (page) => page.data?.transactions || [],
  )

  return (
    <Row className='min-h-screen items-start mb-8xl md:mb-3'>
      <Card className='flex-1' withoutBorder>
        <Col>
          {isLoading && (
            <div className='space-y-2'>
              <Skeleton className='w-full h-20' />
              <Skeleton className='w-full h-20' />
              <Skeleton className='w-full h-20' />
            </div>
          )}
          {transactions?.map((transaction, index) => (
            <Fragment key={transaction.id}>
              {index !== 0 && <Separator />}
              <BalanceItem {...transaction} />
            </Fragment>
          ))}
          {transactions?.length === 0 && !isLoading && <BalanceEmptyState />}
          <LoadMoreSection
            fetchNextPage={fetchNextPage}
            hasNextPage={hasNextPage}
            isFetchingNextPage={isFetchingNextPage}
            isLoading={isLoading}
          />
        </Col>
      </Card>
    </Row>
  )
}
